import React from "react";

import { Button } from "antd";

import { ReactComponent as LoadingDots } from "../../../assets/images/common/LoadingDots.svg";
import "./LoadingConfirmBtn.css";

export default function LoadingConfimBtn({ text }) {
  return (
    <Button htmlType="button" type="primary" disabled onClick={() => {}} className="CommonLoadingBtn">
      {text && <span>{text}</span>}
      <LoadingDots width={16} />
    </Button>
  );
}
